module.exports = __webpack_public_path__ + "img/39.8840491.webp";